import { Dispatch } from "redux"
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getSinesters = (page: number | null = null, limit: number | null = null, search: Object = '', sort: any = null) => async (dispatch: Dispatch) => {
    dispatch({ type: 'SINESTER_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/sinester/getall/', { page, limit, search, sort }, {
            headers: { auth: localStorage.getItem('jwt'), ente: localStorage.getItem('enteId') }
        })
        if (status === 200) {
            dispatch({
                type: 'SINESTER_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'SINESTER_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'SINESTER_NOT_LOADING' })
    }
}

export const getSinestersByPolicy = (policyId: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'SINESTER_LOADING' })
    try {
        const { data, status } = await Axios.get(`/api/sinester/getAllByPolicy/${policyId}`,
            {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'SINESTER_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'SINESTER_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'SINESTER_NOT_LOADING' })
    }
}


export const getForSelect = () => async (dispatch: Dispatch) => {
    dispatch({ type: 'SINESTER_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/sinester/getforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SINESTER_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'SINESTER_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'SINESTER_NOT_LOADING' })
    }
}

export const getSinester = (sinester: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'SINESTER_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/sinester/get/' + sinester, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SINESTER_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'SINESTER_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'SINESTER_NOT_LOADING' })
    }
}

export const readSinester = (idSinester: string) => async (dispatch: Dispatch) => {
    dispatch({
        type: 'SINESTERDATA_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/sinester/readSinester/' + idSinester, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 304) {
            dispatch({
                type: 'SINESTERDATA_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'SINESTERDATA_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SINESTERDATA_NOT_LOADING'
        })
    }
}

export const addSinester = (sinesterdata: any) => async (dispatch: Dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/sinester/register', sinesterdata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SINESTER_ADD_SUCCESS',
                payload: data
            })
        } else if (status === 264 || status === 260) {
            dispatch({
                type: 'SINESTER_WRONG_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'SINESTER_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'SINESTER_NOT_LOADING' })
    }
}

export const editSinester = (sinester: any, id?: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'SINESTER_LOADING' })
    try {
        const { data, status } = await Axios.put('/api/sinester/edit/' + id, sinester, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'SINESTER_EDIT_SUCCESS',
                payload: { message: data.message, id, updatedSinester: sinester }
            })
        } else {
            dispatch({ type: 'SINESTER_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'SINESTER_NOT_LOADING' })
    }
}

export const getSinesterTypes = () => async (dispatch: Dispatch) => {
    const { data, status } = await Axios.get('/api/sinester/getalltypes/', {
        headers: { auth: localStorage.getItem('jwt') }
    })
    if (status === 200) {
        dispatch({
            type: 'SINESTERTYPE_GETALL_SUCCESS',
            payload: data
        })
    }
}

export const importSinesterTypesFromEbroker = () => async (dispatch: Dispatch) => {
    dispatch({
        type: 'SINESTERTYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/sinester/getalltypesbroker/', {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200) {
            dispatch({
                type: 'SINESTERTYPE_IMPORT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'SINESTERTYPE_NOT_LOADING'
        })
    }
}

export const getInvolvedTypes = () => async (dispatch: Dispatch) => {
    const { data, status } = await Axios.get('/api/sinester/getallinvolvedtypes/', {
        headers: { auth: localStorage.getItem('jwt') }
    })
    if (status === 200) {
        dispatch({
            type: 'INVOLVEDTYPE_GETALL_SUCCESS',
            payload: data
        })
    }
}

export const importInvolvedTypesFromEbroker = () => async (dispatch: Dispatch) => {
    dispatch({
        type: 'INVOLVEDTYPE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/sinester/getallinvolvedtypesebroker/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'INVOLVEDTYPE_IMPORT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'INVOLVEDTYPE_NOT_LOADING'
        })
    }
}